import React, { useEffect, useRef, useState } from "react";
import ProfileDetailsTab from "./ProfileDetailsTab";
import ContactDetailsTab from "./ContactDetailsTab";
import BankDetailsTab from "./BankDetailsTab";
import PaymentDetailsTab from "./PaymentDetailsTab";
// import SettingsTab from "./SettingsTab";
import { useTranslation } from "react-i18next";
import AdditionalDetails from "./AdditionalDetailsTab";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import KycTab from "./KycTab";
import { toast } from "react-toastify";

const ProfileLayout = ({ profile }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("firstTab");

  const showBankDetails = useSelector(
    (state) => state.user.profile.bankDetails
  );
  const containerRef = useRef(null);

  const handleTabClick = (tabId) => {

    const personalDetailsCheck =
      (!profile?.personalDetails.gender ||
      !profile?.personalDetails.dob ||
      !profile?.personalDetails.name ||
      !profile?.personalDetails.secondName ||
      !profile?.personalDetails.relation ||
      !profile?.personalDetails.nomineeName);

    const contactDetailsCheck =
      !profile?.contactDetails.address ||
      !profile?.contactDetails.address2 ||
      !profile?.contactDetails.city ||
      !profile?.contactDetails.state ||
      !profile?.contactDetails.country ||
      !profile?.contactDetails.zipCode ||
      !profile?.contactDetails.mobile ||
      !profile?.contactDetails.district;

    const kycDetails =
      !profile?.kycDetails?.aadhaarImg ||
      !profile?.kycDetails?.aadhaarStatus ||
      !profile?.kycDetails?.aadharNumber ||
      !profile?.kycDetails?.bankPassbookImg ||
      !profile?.kycDetails?.bankPassbookStatus ||
      // !profile?.kycDetails?.gstin ||
      // !profile?.kycDetails?.gstinImg ||
      // !profile?.kycDetails?.gstinStatus ||
      !profile?.kycDetails?.panImg ||
      !profile?.kycDetails?.panName ||
      !profile?.kycDetails?.panNumber ||
      !profile?.kycDetails?.panStatus ||
      !profile?.kycDetails?.signatureImg ||
      !profile?.kycDetails?.signatureStatus;

    const bankDetailsCheck = !profile?.bankDetails?.accountNo ||
      !profile?.bankDetails?.ifsc ||
      !profile?.bankDetails?.bankName ||
      !profile?.bankDetails?.holderName ||
      !profile?.bankDetails?.branchName;

    // if (tabId === "secondTab" && personalDetailsCheck) {
    //   return toast.error("Please fill personal details first");
    // } else if (tabId === "sixthTab" && contactDetailsCheck || personalDetailsCheck) {
    //   return toast.error("Please add contact details and personal details first");
    // } else if (tabId === "thirdTab" && kycDetails) {
    //   return toast.error("Please add KYC details first");
    // }
    if (tabId === "secondTab" && personalDetailsCheck) {
      return toast.error("Please fill personal details first");
    } else if (tabId === "thirdTab" && contactDetailsCheck || personalDetailsCheck) {
      return toast.error("Please add contact details and personal details");
    } else if (tabId === "sixthTab" && bankDetailsCheck) {
      return toast.error("Please add Bank details");
    }
    setActiveTab(tabId);
  };

  useEffect(() => {
    if (location.pathname === "/profile/payment-details") {
      handleTabClick("fourthTab");
    }
  }, [location.pathname]);

  return (
    <div className="profileTabSec">
      <div className="profileTabBg">
        <div className="tab">
          <button
            className={`tablinks ${activeTab === "firstTab" ? "active" : ""}`}
            onClick={() => handleTabClick("firstTab")}
          >
            {t("personalDetails")}
          </button>
          <button
            className={`tablinks ${activeTab === "secondTab" ? "active" : ""}`}
            onClick={() => handleTabClick("secondTab")}
          >
            {t("contactDetails")}
          </button>
          {/* <button
            className={`tablinks ${activeTab === "fourthTab" ? "active" : ""}`}
            onClick={() => handleTabClick("fourthTab")}
          >
            {t("paymentDetails")}
          </button> */}
          {profile?.additionalDetails?.length > 0 && (
            <button
              className={`tablinks ${activeTab === "fifthTab" ? "active" : ""}`}
              onClick={() => handleTabClick("fifthTab")}
            >
              {t("additionalDetails")}
            </button>
          )}
            {showBankDetails && (
              <button
                className={`tablinks ${activeTab === "thirdTab" ? "active" : ""}`}
                onClick={() => handleTabClick("thirdTab")}
              >
                {t("bankDetails")}
              </button>
            )}
          <button
            className={`tablinks ${activeTab === "sixthTab" ? "active" : ""}`}
            onClick={() => handleTabClick("sixthTab")}
          >
            KYC Details
          </button>
        </div>
        <div ref={containerRef}></div>
        {activeTab === "firstTab" && <ProfileDetailsTab kycStatus={profile?.profile?.kycStatus} />}
        {activeTab === "secondTab" && profile?.contactDetails && (
          <ContactDetailsTab
            contact={profile?.contactDetails}
            countries={profile?.countries}
            districts={profile?.districts}
          />
        )}
        {activeTab === "thirdTab" && profile?.bankDetails && (
          <BankDetailsTab bank={profile?.bankDetails} kycStatus={profile?.profile?.kycStatus} />
        )}
        {activeTab === "fourthTab" && profile?.payoutDetails && (
          <PaymentDetailsTab payment={profile?.payoutDetails}/>
        )}
        {activeTab === "fifthTab" && profile?.additionalDetails && (
          <AdditionalDetails additional={profile?.additionalDetails} />
        )}
        {activeTab === "sixthTab" && profile?.kycDetails && (
          <KycTab kyc={profile?.kycDetails} kycStatus={profile?.profile?.kycStatus} email={profile?.profile?.email} emailVerified={profile?.profile?.emailVerified} />
        )}
      </div>
    </div>
  );
};

export default ProfileLayout;
